"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScopeChecker = exports.ScopeChecker = function () {
  function ScopeChecker(scope, isolateModule) {
    _classCallCheck(this, ScopeChecker);

    this.scope = scope;
    this.isolateModule = isolateModule;
  }

  _createClass(ScopeChecker, [{
    key: "isStrictlyInRootScope",
    value: function isStrictlyInRootScope(leaf) {
      // eslint-disable-line complexity
      for (var el = leaf; el; el = el.parentElement) {
        var scope = this.isolateModule.isIsolatedElement(el);
        if (scope && scope !== this.scope) {
          return false;
        }
        if (scope) {
          return true;
        }
      }
      return true;
    }
  }]);

  return ScopeChecker;
}();


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/ScopeChecker.js
 **/